import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Message from "../components/LoadingError/Error";
import Loading from "../components/LoadingError/Loading";
import { register, sendOTP, verifyOTP } from "../Redux/Actions/userActions";
import Header from "./../components/Header";
import MobileNav from "../components/MobileNav";
import {
  DEFAULT_MOBILE_LENGTH,
  DEFAULT_MOBILE_PREFIX,
} from "../Redux/Constants/GlobalConstant";
import { OTP_REQUEST_FAIL } from "../Redux/Constants/UserContants";

const Register = ({ location, history, match }) => {
  const refId = match.params.refId;

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password] = useState("default");
  const [mobile, setMobile] = useState("");
  const [otp, setOTP] = useState("");
  const [ref_id, setRefId] = useState(refId ? refId : "");
  const [showOTP, setShowOTP] = useState(false);
  const [showOTPLoader] = useState(false);
  const [showOTPSendButton, setShowOTPSendButton] = useState(true);
  const [otpError, setOTPError] = useState(null);

  const dispatch = useDispatch();
  const redirect = location.search ? location.search.split("=")[1] : "/cart";
  const redirect0 = location.search
    ? location.search.split("=")[0]
    : "/login-otp";

  const userRegister = useSelector((state) => state.userRegister);
  const { error, loading, userInfo } = userRegister;

  const otpData = useSelector((state) => state.otp);
  const { otpInfo, otpVerifyInfo } = otpData;

  useEffect(() => {
    if (userInfo) {
      history.push(redirect);
    }
    if (redirect0 === "?phone") {
      console.log("redirect0", redirect);
      setMobile(redirect);
      if (/^\d{11}$/.test(redirect)) {
        setShowOTP(true);
        setShowOTPSendButton(true);
      } else {
        setOTPError("Invalid Mobile Number");
        // alert("Invalid Mobile Number");
      }
    }
  }, [userInfo, history, redirect, redirect0]);

  useEffect(() => {
    if (!otpVerifyInfo) return;

    if (otpVerifyInfo.status === "success") {
      dispatch(register(name, mobile, email, password));
    } else {
      setOTPError(otpVerifyInfo.message);
    }
  }, [otpVerifyInfo, name, mobile,email, password, dispatch]);

  //To Clear the Error Messages
  useEffect(() => {
    if (error || otpError) {
      // setOTPError(null);
      const timer = setTimeout(() => {
        setOTPError(null);
        dispatch({ type: OTP_REQUEST_FAIL, payload: null });
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [error, dispatch, otpError]);

  const submitHandler = async (e) => {
    e.preventDefault();

    if (mobile.length < 11) {
      setOTPError("Enter Valid Mobile");
      return false;
    }
    if (otp.length < 6) {
      setOTPError("Enter Valid OTP");
      return false;
    }
    await dispatch(verifyOTP(mobile, otp));
  };

  const mobileHandler = (e) => {
    // Ensure the mobile number starts with zero
    if (e.length > 0 && e[0] !== DEFAULT_MOBILE_PREFIX) {
      e = DEFAULT_MOBILE_PREFIX + e;
      // setOTP(e);
    }
    if (e.length > 11) return false;
    setMobile(e);
    if (e.length === DEFAULT_MOBILE_LENGTH) {
      if (new RegExp(`^\\d{${DEFAULT_MOBILE_LENGTH}}$`).test(e)) {
        setShowOTP(true);
      } else {
        alert("Invalid Mobile Number");
        setOTPError("Invalid Mobile Number");
      }
    } else setShowOTP(false);
  };

  const handleOTP = () => {
    dispatch(sendOTP(mobile, email));
    setShowOTPSendButton(false);

    setTimeout(() => {
      setShowOTPSendButton(true);
    }, 30000);
  };

  return (
    <>
      <Header />
      <MobileNav />
      <div className="container d-flex flex-column justify-content-center align-items-center login-center">
        {(error || otpError) && (
          <Message variant="alert-danger">
            {otpError ? otpError : error}
          </Message>
        )}
        {(loading || showOTPLoader) && !otpInfo?.message && <Loading />}
        {otpInfo?.message}
        {otpError}
        <form
          className="Login col-md-8 col-lg-4 col-11"
          onSubmit={submitHandler}
        >
          <div className="mobile-otp-button">
            <input
              type="text"
              pattern="[0-9]*"
              placeholder="Mobile"
              value={mobile}
              onChange={(e) => mobileHandler(e.target.value)}
              required
              inputMode="numeric"
            />
            {showOTP && (
              <button
                type="button"
                onClick={(e) => handleOTP()}
                disabled={!showOTPSendButton}
              >
                {!otpInfo?.status && "Send OTP"}
                {otpInfo?.status && "Send Again"}
              </button>
            )}
          </div>

          {showOTP && (
            <input
              type="text"
              inputMode="numeric"
              placeholder="OTP"
              value={otp}
              onChange={(e) =>
                setOTP(e.target.value.replace(/[^0-9]/g, "").slice(0, 6))
              }
              required
              maxLength={6}
              pattern="[0-9]*"
            />
          )}
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="text"
            placeholder="Reference (Optional)"
            value={ref_id}
            onChange={(e) => setRefId(e.target.value)}
            disabled={true}
          />

          <button type="submit">
            {!showOTP && "Register"} {showOTP && "Verify & Submit"}
          </button>
          <p>
            <Link to={redirect ? `/login-otp` : "/login-otp"}>
              Click Here to <strong>Login</strong>
            </Link>
          </p>
          <p className="privacy-policy-links">
            By continuing, you agree to our{" "}
            <Link to="/term-condition"> Terms of service </Link> &{" "}
            <Link to="/policy">Privacy policy </Link>
          </p>
        </form>
      </div>
    </>
  );
};

export default Register;
